// extracted by mini-css-extract-plugin
module.exports = {"card":"event_card__DM_Lv"};